require('inpage_confirm')
$.rails.allowAction = (element) ->
  message = element.data 'confirm'
  answer = false
  return true unless message
  if ($.rails.fire(element, 'confirm'))
    # lp extension.
    answer = $.rails.confirm message, element
    callback = $.rails.fire element, 'confirm:complete', [answer]
  answer && callback

$.rails.confirm = (message, element) ->
  if $(element).attr('data-modal-confirm')?
    ModalConfirm.data_modal_confirm $(element)
    # ModalConfirm handles triggering the link
    false
  else if $(element).attr('data-inpage-confirm')?
    LP.module('InlineConfirm').data_confirm $(element)
    # InlineConfirm handles triggering the link
    false
  else
    confirm(message)

ModalConfirm =
  data_modal_confirm: ($element) ->
    defaults =
      title: $element.attr('title') || 'Confirm',
      message: $element.data('confirm') || 'Are you sure?',
      confirm_button_text: 'Ok',
      method: $element.data('method') || 'get',
      remote: $element.data('remote') || false,
      datatype: $element.data('type') || null,
      href: $element.attr('href'),
      klasses: $element.data('klasses') || ""

    options = $.extend defaults, $element.data('modal-confirm')

    html = """
             <div id="modal-confirm-dialog" class="modal fade in">
               <div class="modal-dialog"><div class="modal-content">
                 <div class="modal-header">
                   <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                   <h3>#{options.title}</h3>
                 </div>
                 <div class="modal-body">
                   <p>#{options.message}</p>
                 </div>
                 <div class="modal-footer">
                   <a class="btn btn-primary confirm #{options.klasses}">#{options.confirm_button_text}</a>
                   <a class="btn btn-default" data-dismiss="modal">Cancel</a>
                 </div>
               </div></div>
             </div>
           """

    # Create this DOM element
    $dialog = $(html)
    $('body').append($dialog) # Required so that `Bootstrap Scroll Modal` can wrap this DOM element
    $confirm_button = $('.confirm', $dialog).attr
      'data-method': options.method
      'href': options.href
      'data-remote': if options.remote then "true" else null
      'data-type': if options.datatype then options.datatype else null

    # display the modal and fire an event
    $dialog.modal()
    $element.trigger 'modal-confirm:display', [$dialog]

    # if the confirmation link is remote we'll fire some events on error and success
    $confirm_button.on 'ajax:success:display', (e, messages, $messages)->
      $dialog.modal 'hide'
      $element.trigger 'modal-confirm:success', [messages, $messages]

    $confirm_button.on 'ajax:error:display', (e, errors, $errors) ->
      $('.modal-body', $dialog).html $errors
      $element.trigger 'modal-confirm:error', [errors, $errors]

    # if the element that triggered the modal-confirm is a submit then
    # submit the form on click of the confirm button
    if $element.is(':submit')
      $confirm_button.on 'click', (e) ->
        e.stopPropagation()
        $element.closest('form').submit()

    # once hidden, it can be removed as it won't ever be used again
    $dialog.on 'hidden.bs.modal', ->
      $(this).remove()
